import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
    Button,
    Container,
    Col,
    Row,
    Label,
    Collapse,
    FormGroup,
    Input,
} from 'reactstrap'

import CartWhiteIcon from '../../assets/img/icons/SHOPPING_WHITE.svg'
import CartIcon from '../../assets/img/icons/SHOPPING.svg'
import Icon from '../../components/Icons/Icon'

import CartItem from './Cart/CartItem/CartItem'

import './Index.css'
import { useDispatch, useSelector } from 'react-redux'
import { getUserFullname } from '../../services/authenticationChecker'
import {
    buyOrder,
    removeFromCart,
    updateCartMeterage,
} from '../../redux/payment/actions'
import PaymentSidebar from './Sidebar/PaymentSidebar'
import Loading from '../../components/Loading/Loading'

const Index = () => {
    const cartItems = useSelector((state) => state.payment.cart)
    const submittingOrder = useSelector(
        (state) => state.payment.submittingOrder
    )

    const dispatch = useDispatch()
    const history = useHistory()

    const [deliverOnStore, setDeliverOnStore] = useState(false)
    const [deliverOnAddress, setDeliverOnAddress] = useState(false)
    const addresses = useSelector((state) => state.payment.addresses)

    const onAddressChanged = (e) => {}
    const onRadioChanged = (e) => {
        if (e.target.id === 'deliverOnStore') {
            setDeliverOnAddress(false)
            setDeliverOnStore(true)
        } else if (e.target.id === 'deliverOnAddress') {
            setDeliverOnAddress(true)
            setDeliverOnStore(false)
        }
    }

    const onBuy = () => {
        dispatch(buyOrder(history))
    }

    const onRemoveCartItem = (id) => {
        dispatch(removeFromCart(id))
    }
    const onCartItemEdited = (id, newMeterage) => {
        dispatch(updateCartMeterage(id, newMeterage))
    }

    return (
        <div className="cart payment">
            <h3 className="cart__header">
                <Icon src={CartWhiteIcon} size="xlg" />
                سبد خرید
            </h3>
            <div className="cart__header-wrapper">
                <Button
                    className="d-flex align-items-center"
                    color="link"
                    onClick={() => history.goBack()}
                >
                    <span className="back-icon">&lsaquo;</span>بازگشت
                </Button>
            </div>
            {submittingOrder && <Loading />}
            <Container>
                <Row>
                    <Col md={2}></Col>
                    <Col className="cart__items" md={7}>
                        <div className="payment__name-wrapper">
                            <Label>خریدار</Label>
                            <p className="payment__name">{getUserFullname()}</p>
                        </div>
                        <FormGroup tag="fieldset" className="text-right">
                            <legend>نوع تحویل</legend>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        id="deliverOnStore"
                                        name="delivery"
                                        onChange={onRadioChanged}
                                    />{' '}
                                    تحویل در فروشگاه
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        id="deliverOnAddress"
                                        name="delivery"
                                        onChange={onRadioChanged}
                                    />{' '}
                                    تحویل در محل شما
                                </Label>
                            </FormGroup>
                        </FormGroup>
                        {/* <Collapse isOpen={deliverOnAddress}>
                     <div className="d-flex payment__address-wrapper">
                        <Label>آدرس</Label>
                        <Input placeholder="آدرس خود را بنویسید" />
                     </div>
                     {
                        !isEmpty(addresses) && <FormGroup tag="fieldset" className="text-right">
                           <legend>آدرس‌ها</legend>
                           {addresses.map(address => <FormGroup check>
                              <Label check>
                                 <Input type="radio" id={address} name="address" onChange={onAddressChanged} />{' '}
                                 {address}
                              </Label>
                           </FormGroup>)}
                        </FormGroup>
                     }
                  </Collapse> */}
                        {cartItems.map((cart) => (
                            <CartItem
                                {...cart}
                                onRemove={onRemoveCartItem}
                                onEdited={onCartItemEdited}
                            />
                        ))}
                    </Col>
                    <Col className="cart__sidebar" md={3}>
                        <PaymentSidebar>
                            <Button
                                className="cart__add-to-cart-btn"
                                onClick={onBuy}
                            >
                                <Icon src={CartIcon} size="xlg" />
                                تائید و ثبت سفارش
                            </Button>
                        </PaymentSidebar>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Index
